import { type CalendarItem, dayParts } from "@/lib/overview";
import { Box, Text } from "@okshaun/components";
import { CalendarChip } from "./calendar-chip";

interface CalendarStripProps {
  days: string[];
  today: string;
  byDay: Map<string, CalendarItem[]>;
}

export function CalendarStrip({ days, today, byDay }: CalendarStripProps) {
  return (
    <Box display="grid" gridTemplateColumns="[repeat(14, minmax(0, 1fr))]" gap="12">
      {days.map((day) => {
        const { dow, date, weekend } = dayParts(day);
        const isToday = day === today;
        const headColor = isToday ? "text.bold" : weekend ? "text.disabled" : "text.subtle";
        return (
          <Box
            key={day}
            display="flex"
            flexDir="column"
            gap="6"
            minW="0"
            bg={isToday ? "surface.raised" : "transparent"}
            borderRadius="4"
            p={isToday ? "6" : "0"}
            m={isToday ? "-6" : "0"}
          >
            <Box display="flex" gap="6" alignItems="baseline" pb="6" borderBottom="default">
              <Text textStyle="mono.xs" color={headColor}>
                {dow}
              </Text>
              <Text textStyle="mono.sm" color={headColor} fontWeight="medium">
                {date}
              </Text>
              {isToday && (
                <Text textStyle="mono.xs" color="text.accent.purple.bold">
                  today
                </Text>
              )}
            </Box>
            <Box display="flex" flexDir="column" gap="4">
              {(byDay.get(day) ?? []).map((item) => (
                <CalendarChip key={item.id} item={item} />
              ))}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
